<div class="container-fluid py-4">
  <div class="row">
    <div class="col-12">
      <!-- Header -->
      <div class="card shadow-sm rounded-3 mb-4">
        <div class="card-body py-3 px-4 d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center gap-2">
            <i class="bi bi-gear-fill text-primary"></i>
            <span class="text-dark text-sm fw-bold">Thank You Page Configuration</span>
            <span v-if="has_changes" class="badge bg-warning text-dark ms-2 text-xxs">Unsaved changes</span>
          </div>
          <div class="d-flex gap-2">
            <!-- JSON Actions -->
            <div class="btn-group me-2">
              <button 
                class="btn btn-outline-primary text-xs rounded-small btn-sm" 
                @click="import_json"
                title="Import from JSON file"
              >
                <i class="bi bi-upload me-1"></i> Import
              </button>
              <button 
                class="btn btn-outline-primary text-xs rounded-small btn-sm" 
                @click="export_json"
                title="Export as JSON file"
              >
                <i class="bi bi-download me-1"></i> Export
              </button>
              <button 
                class="btn text-xs rounded-small btn-sm"
                :class="show_json_preview ? 'btn-primary' : 'btn-outline-primary'"
                @click="toggle_json_preview"
                title="Toggle JSON preview"
              >
                <i class="bi bi-code-slash"></i>
              </button>
            </div>
            <button 
              class="btn btn-outline-secondary text-xs rounded-small btn-sm" 
              @click="undo_changes"
              :disabled="!has_changes || is_saving"
              title="Undo changes"
            >
              <i class="bi bi-arrow-counterclockwise me-1"></i> Undo
            </button>
            <button 
              class="btn btn-outline-warning text-xs rounded-small btn-sm" 
              @click="reset_to_defaults"
              :disabled="is_saving"
              title="Reset to default values"
            >
              <i class="bi bi-arrow-repeat me-1"></i> Reset
            </button>
            <button 
              class="btn btn-bg-green text-xs rounded-small btn-sm" 
              @click="save_configuration"
              :disabled="is_saving"
            >
            <span v-if="is_saving">
              <i class="fas fa-spinner fa-spin me-1"></i> Saving...
            </span>
            <span v-else>
              <i class="bi bi-save me-1"></i> Save Configuration
            </span>
            </button>
          </div>
        </div>
      </div>

      <!-- JSON Preview Panel -->
      <div v-if="show_json_preview" class="card shadow-sm rounded-3 mb-4 border-primary">
        <div class="card-header bg-white d-flex justify-content-between align-items-center">
          <h6 class="text-sm pt-2 mb-0">
            <i class="bi bi-code-slash me-2 text-primary"></i>
            JSON Configuration
          </h6>
          <button 
            class="btn btn-sm btn-outline-primary text-xs rounded-small" 
            @click="copy_json"
            title="Copy to clipboard"
          >
            <i class="bi bi-clipboard me-1"></i> Copy
          </button>
        </div>
        <div class="card-body p-0">
          <pre class="m-0 p-3 bg-dark text-light rounded-bottom" style="font-size: 0.75rem; max-height: 300px; overflow: auto;"><code>{{ json_preview }}</code></pre>
        </div>
      </div>

      <!-- Loading State -->
      <div v-if="is_loading" class="text-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <p class="mt-2 text-muted text-sm">Loading configuration...</p>
      </div>

      <!-- Page Builder Component -->
      <PageBuilder 
        v-else
        v-model="configuration"
        :show-preview="true"
      />
    </div>
  </div>
</div>
